import { Container } from "@material-ui/core";
import { useCallback, useMemo } from "react";

import { ContentSection } from "../../application/ContentSection";
import { useTranslation } from "../../internationalisation/translation.hook";
import { ListSectionAlt, ListSectionAltProps } from "../../components/list-section-alt/ListSectionAlt";
import { TaskDocument } from "../../task/task.model";
import { Section } from "../../components/section/Section";
import { SectionHeader } from "../../components/section/SectionHeader";
import { mapTaskToTaskItem, sortTaskByDateAndCustomerName } from "../current-tasks/CurrentTasksTab";
import { OverviewGuideList } from "../../guides/OverviewGuideList";
import { GardenerDocument } from "../../gardener/gardener.model";
import { TaskResponseData } from "../../task/task-response-action.hook";

type Task = Extract<TaskDocument, { type: "appointment-follow-up" | "registration-follow-up" }>;

interface FutureTasksTabProps {
    goToTask: (task: Task) => void;
    taskResponseAction: (data: TaskResponseData | string) => void;
    gardener: GardenerDocument;
    tasks: Task[];
    now: string;
}

export const FutureTasksTab = (props: FutureTasksTabProps) => {
    const { t } = useTranslation();

    const { goToTask, taskResponseAction, gardener, tasks, now } = props;

    const futureTasks = useMemo(() => {
        return tasks.sort(sortTaskByDateAndCustomerName);
    }, [tasks]);

    const goToFutureTask = useCallback(index => goToTask(futureTasks[index]), [goToTask, futureTasks]);

    const futureTaskItems = useMemo<ListSectionAltProps["items"]>(() => {
        return tasks.map(task => mapTaskToTaskItem(task, now, t));
    }, [t, tasks, now]);

    return (
        <ContentSection>

            <Container maxWidth="sm" disableGutters>

                <ListSectionAlt
                    title={t("FutureTasksTab: future-header")}
                    placeholder={t("FutureTasksTab: future-placeholder")}
                    items={futureTaskItems}
                    onClick={goToFutureTask}
                />

            </Container>

            <Container maxWidth="md" disableGutters>
                <Section>
                    <SectionHeader>Relevante guides</SectionHeader>
                    <OverviewGuideList gardener={gardener} taskResponseAction={taskResponseAction} />
                </Section>
            </Container>

        </ContentSection>
    );
};
